import React from "react";
import useApi from "../../hooks/useApi";

export default ({ type = "info", optionName = null, children, ...modifiers }) => {
  const { data: siteOptions, loading } = useApi("/options");
  if(optionName && loading){
    return "";
  }
  const content = (optionName) ? siteOptions[optionName] : children;
  if(content==="") return "";
  return (
    <div
      className={"notice -" + type}
      dangerouslySetInnerHTML={{ __html: content }}
    >
    </div>
  );
};
